// extracted by mini-css-extract-plugin
export default {"solvedacWrapper":"solvedacContainer_solvedacWrapper__Vmo4U"};